export default __webpack_public_path__ + "static/media/lgp2.00242c23.png";